import { Option, none, isNone, some } from 'fp-ts/lib/Option';
import { UpdateDashboardCriteria } from 'use-case/dashboard/update/updateDashboardCriteria';

export interface UpdateDashboardStarCriteria extends UpdateDashboardCriteria {
    starred: boolean;
}

class UpdateDashboardStarCriteriaImpl implements UpdateDashboardStarCriteria {
    constructor(readonly id: string, readonly starred: boolean) {}
}

export class UpdateDashboardStarCriteriaBuilder {
    private id: Option<string> = none;

    private starred: Option<boolean> = none;

    static create = (): UpdateDashboardStarCriteriaBuilder => new UpdateDashboardStarCriteriaBuilder();

    withId = (id: string): UpdateDashboardStarCriteriaBuilder => {
        this.id = some(id);
        return this;
    };

    withStarred = (starred: boolean): UpdateDashboardStarCriteriaBuilder => {
        this.starred = some(starred);
        return this;
    };

    build = (): UpdateDashboardStarCriteria => {
        if (isNone(this.id) || isNone(this.starred)) {
            throw new ReferenceError('Undefined prop');
        }

        return new UpdateDashboardStarCriteriaImpl(this.id.value, this.starred.value);
    };
}
